let vars = {}

const globals = (name, value) => {
  if (!value) {
    return vars[name]
  }

  vars[name] = value

  return vars[name]
}

export default globals
